"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _blockEdit = _interopRequireDefault(require("../../../block-edit"));
var _styled = require("../../../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SkillItem = function SkillItem(_ref) {
  var student = _ref.student,
    onClickEdit = _ref.onClickEdit,
    isEdit = _ref.isEdit;
  var skills = student.technicalSkill.filter(function (a) {
    return a.added === 1 && a.includeOnResume;
  });
  var languages = student.languages.filter(function (language) {
    return language.added === 1 && language.includeOnResume;
  });
  var personalInterests = student.personalInterests.filter(function (a) {
    return a.added === 1 && a.includeOnResume;
  });
  var certifications = student.certificationsAndLicences.filter(function (a) {
    return a.added === 1 && a.includeOnResume;
  });
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1B_TECHNICAL_SKILLS, true);
    },
    title: "Computer/Technical",
    color: "#85317f",
    isEdit: isEdit,
    show: !(0, _isEmpty.default)(skills)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, skills.map(function (a) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: a.name
    }, "".concat(a.proficiencyName === 'Proficient' ? a.name : "".concat(a.name, " (").concat(a.proficiencyName, ")")));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1B_LANGUAGES, true);
    },
    title: "Language Skills",
    color: "#85317f",
    isEdit: isEdit,
    show: !(0, _isEmpty.default)(languages)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, languages.map(function (language) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "".concat(language.proficiency).concat(language.name)
    }, "".concat(language.proficiencyName === 'Proficient' ? language.languageName : "".concat(language.languageName, " (").concat(language.proficiencyName, ")")));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1B_PERSONAL_INTERESTS, true);
    },
    title: "Personal Interests",
    color: "#85317f",
    isEdit: isEdit,
    show: !(0, _isEmpty.default)(personalInterests)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, personalInterests.map(function (interest) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: interest.name
    }, interest.name);
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1B_CERTIFICATES_AND_LICENSES, true);
    },
    title: "Certifications & Licenses",
    color: "#85317f",
    isEdit: isEdit,
    show: !(0, _isEmpty.default)(certifications)
  }, /*#__PURE__*/_react.default.createElement(_styled.List, null, certifications.map(function (certification) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: certification.name
    }, certification.name);
  }))));
};
SkillItem.propTypes = {
  student: _utils.studentProps.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  isEdit: _propTypes.default.bool.isRequired
};
var _default = SkillItem;
exports.default = _default;